import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import '../whatsapp.css';

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/94741250699?text=Hello%2Escapio%20Travels%20I%20want%20to%20know%20more%20about%20your%20package."
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={30} />
    </a>
  );
}

export default WhatsAppButton;
